// interface Props {}

import { selectProvinceSelected } from '@containers/App/selectors';
import dynamic from 'next/dynamic';
import { useRouter } from 'next/router';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';

const LoadingContainer = dynamic(() => import('@components/LoadingContainer'));

function Province() {
  const router = useRouter();

  const provinceSelected = useSelector(selectProvinceSelected);

  useEffect(() => {
    if (provinceSelected) router.replace(`/${provinceSelected}/discover`);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [provinceSelected]);

  return <LoadingContainer loading />;
}

export default Province;
